/* Sacred 7 offer: sticky bar visibility + click tracking */
(function () {
  function track(evt, placement) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: evt, s7_placement: placement });
      if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', evt === 's7_subscribe_click' ? 'Clicked Sacred 7 Subscribe' : 'Clicked Sacred 7 Buy Once', { placement: placement }]);
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.hasAttribute && f.hasAttribute('data-s7-form')) track('s7_subscribe_click', f.getAttribute('data-placement'));
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-s7-once]');
    if (a) track('s7_buy_once_click', a.getAttribute('data-placement'));
  }, true);

  var bar = document.querySelector('[data-s7-bar]');
  if (!bar) return;
  var dismissed = false;
  try { dismissed = sessionStorage.getItem('s7BarClosed') === '1'; } catch (e) {}
  if (dismissed) return;

  var heroes = Array.prototype.slice.call(document.querySelectorAll('[data-s7-hero], .s7--inline, [data-s7-hide-bar]'));
  var visibleHeroes = 0;
  var scrolledEnough = false;
  bar.hidden = false;

  function update() {
    var show = scrolledEnough && visibleHeroes === 0;
    bar.classList.toggle('is-in', show);
    document.body.classList.toggle('s7-bar-on', show);
  }
  window.addEventListener('scroll', function () {
    var s = window.pageYOffset > 600;
    if (s !== scrolledEnough) { scrolledEnough = s; update(); }
  }, { passive: true });

  if ('IntersectionObserver' in window && heroes.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.__s7v = true; } else { en.target.__s7v = false; }
      });
      visibleHeroes = heroes.filter(function (h) { return h.__s7v; }).length;
      update();
    }, { threshold: 0.2 });
    heroes.forEach(function (h) { io.observe(h); });
  }

  var close = bar.querySelector('[data-s7-close]');
  if (close) close.addEventListener('click', function () {
    bar.classList.remove('is-in');
    document.body.classList.remove('s7-bar-on');
    try { sessionStorage.setItem('s7BarClosed', '1'); } catch (e) {}
    setTimeout(function () { bar.hidden = true; }, 300);
  });
})();
